/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { FormattedMessage, useIntl } from "react-intl"
import { H2 } from "@carrotfertility/carotene"
import { PlanInfoBadgeContainer } from "../../../../containers/planinfo/PlanInfoBadgeContainer"
import { Spacer } from "../../../atoms/Atoms"
import Badge from "../Badge"
import React from "react"
import {
  getCompletedReimbursementsList,
  getPendingReimbursementsList,
  getReimbursementsRequiringActionList
} from "../ReimbursementListUtils"
import { Legend, ReimbursementsListSection, ReimbursementSummary, TableHeader } from "../SharedReimbursementElements"
import { useSelector } from "react-redux"
import { getCardState } from "../../../../../reducers/userInfo"
import CardStates from "../../../../../utils/CardStates"
import { CircleImage } from "../../../atoms/images/CircleImage"
import { BodySmall } from "../../../atoms/Bodies"

const EmptyReimbursementsList = () => {
  const isCardEligible = useSelector(getCardState) !== CardStates.INELIGIBLE
  return (
    <div>
      <Spacer height={1} />
      <table className="w-100 collapse">
        <thead className="o-40">
          <tr>
            <TableHeader />
          </tr>
        </thead>
        <tbody>
          <tr className="bt bw1 b--black-05">
            <td colSpan="3" className="pv3">
              <div className="w-100 flex justify-center pv5">
                <div className="flex flex-column items-center" style={{ maxWidth: "360px" }}>
                  <CircleImage iconName="icn-transaction" size={84} padding={17} backgroundColor="nurse-gray" />
                  <Spacer height={1.5} />
                  <BodySmall align="tc" color="black-60">
                    {isCardEligible ? (
                      <FormattedMessage defaultMessage="Your Carrot Card® transactions and reimbursement requests will appear here." />
                    ) : (
                      <FormattedMessage defaultMessage="Your reimbursement requests will appear here." />
                    )}
                  </BodySmall>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export const SingleCategoryReimbursementsList = ({ reimbursementsList, subsidy }) => {
  const intl = useIntl()
  const reimbursementsRequiringAction = getReimbursementsRequiringActionList(reimbursementsList)
  const reimbursementsPending = getPendingReimbursementsList(reimbursementsList)
  const reimbursementsCompleted = getCompletedReimbursementsList(reimbursementsList)

  return (
    <>
      {subsidy.hasUnlimitedBenefit || (
        <>
          <H2 variant="primary" stack="tiny">
            <FormattedMessage defaultMessage="Available funds" description="money available to be spent" />
          </H2>
          <ReimbursementSummary
            subsidy={subsidy}
            reimbursementsCount={reimbursementsList ? reimbursementsList.length : 0}
          />
          <PlanInfoBadgeContainer
            backgroundColor={"black-10"}
            fontColor={"black-80"}
            subsidy={subsidy}
            categorySupportsDeductibles={true}
          />
          <Spacer height={3} />
        </>
      )}
      {reimbursementsList.length > 0 ? (
        <>
          <H2 variant="primary">
            <FormattedMessage defaultMessage="Activity" description="things that have been done" />
          </H2>
          <Spacer height={0.5} />
          <Legend />
          <ReimbursementsListSection
            title={
              <Badge badgeContent={intl.formatNumber(reimbursementsRequiringAction.length)} color={"error"}>
                <FormattedMessage defaultMessage="Needs Attention" />
              </Badge>
            }
            emptyText={intl.formatMessage({ defaultMessage: "No transactions need attention" })}
            items={reimbursementsRequiringAction}
          />
          <ReimbursementsListSection
            title={intl.formatMessage({ defaultMessage: "Pending" })}
            emptyText={intl.formatMessage({ defaultMessage: "No pending transactions" })}
            items={reimbursementsPending}
          />
          <ReimbursementsListSection
            title={intl.formatMessage({ defaultMessage: "Complete" })}
            emptyText={intl.formatMessage({ defaultMessage: "No completed transactions" })}
            items={reimbursementsCompleted}
          />
        </>
      ) : (
        <EmptyReimbursementsList />
      )}
    </>
  )
}
